import React from 'react';
import { cn } from '@utils';

const RadioGroup = ({ children, className }) => {

  return <div className={cn(
    "mt-6 flex w-full gap-3",
    className
  )}>
    {children}
  </div>
}

export default RadioGroup;

